import {Component} from "@angular/core";
import {FUIButtonComponent} from "../button.component";

@Component({
    selector: "fui-clear-button",
    styleUrls: ["./clear-button.component.scss"],
    templateUrl: "./clear-button.component.html"
})
export class FUIClearButtonComponent extends FUIButtonComponent {

}
